import { lazy } from "react";

export const VenueLogLayouts = { layout1: lazy(() => import("./Layout1/Layout1")) };
